import { Component } from 'react';

class AreaIcon extends Component {
  render() {
    return (
      <div className="icon spec-icon">
        <i className={`fa fa-${this.props.icon}`} />
      </div>
    );
  }
}

export default AreaIcon;
